module.exports = __webpack_public_path__ + "img/pauseIcon.39b0166e.png";